import { useEffect, useState } from "react";
import { useConsent, type ConsentChoices } from "../contexts/ConsentContext";
import { useLocale } from "../contexts/LocaleContext";
import "./CookieConsentBanner.css";

export function CookieConsentBanner() {
  const {
    consent,
    preferencesOpen,
    acceptAll,
    rejectOptional,
    savePreferences,
    openPreferences,
    closePreferences,
  } = useConsent();
  const { t } = useLocale();
  const [draft, setDraft] = useState<ConsentChoices>({
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    if (preferencesOpen) {
      setDraft(consent || { analytics: false, marketing: false });
    }
  }, [preferencesOpen, consent]);

  if (consent !== null && !preferencesOpen) return null;

  const showDetails = preferencesOpen;

  return (
    <div className="cookie-consent-backdrop" role="presentation">
      <section
        className="cookie-consent"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cookie-consent-title"
      >
        <h2 id="cookie-consent-title">{t("consent.title")}</h2>
        <p>
          {t("consent.intro")} {" "}
          <a href="/#/cookies-policy">{t("consent.policyLink")}</a>
        </p>

        {showDetails && (
          <div className="cookie-consent-options">
            <label>
              <input type="checkbox" checked disabled />
              <span>
                <strong>{t("consent.necessaryTitle")}</strong>
                <small>{t("consent.necessaryText")}</small>
              </span>
            </label>
            <label>
              <input
                type="checkbox"
                checked={draft.analytics}
                onChange={(event) =>
                  setDraft((value) => ({
                    ...value,
                    analytics: event.target.checked,
                  }))
                }
              />
              <span>
                <strong>{t("consent.analyticsTitle")}</strong>
                <small>{t("consent.analyticsText")}</small>
              </span>
            </label>
            <label>
              <input
                type="checkbox"
                checked={draft.marketing}
                onChange={(event) =>
                  setDraft((value) => ({
                    ...value,
                    marketing: event.target.checked,
                  }))
                }
              />
              <span>
                <strong>{t("consent.marketingTitle")}</strong>
                <small>{t("consent.marketingText")}</small>
              </span>
            </label>
          </div>
        )}

        <div className="cookie-consent-actions">
          {showDetails ? (
            <>
              <button type="button" onClick={() => savePreferences(draft)}>
                {t("consent.save")}
              </button>
              {consent !== null && (
                <button type="button" className="secondary" onClick={closePreferences}>
                  {t("consent.cancel")}
                </button>
              )}
            </>
          ) : (
            <>
              <button type="button" onClick={acceptAll}>
                {t("consent.acceptAll")}
              </button>
              <button type="button" className="secondary" onClick={rejectOptional}>
                {t("consent.rejectOptional")}
              </button>
              <button type="button" className="secondary" onClick={openPreferences}>
                {t("consent.settings")}
              </button>
            </>
          )}
        </div>
      </section>
    </div>
  );
}
